/*
 * @Author: YMJ
 * @Date: 2020-10-30 12:19:59
 */
import store from '@/store/index.js';

const TokenKey = 'Admin-Token'

export function getToken() {
    return sessionStorage.getItem(TokenKey);
}

export function setToken(token) {
    sessionStorage.setItem(TokenKey, token)
}

export function removeToken() {
    sessionStorage.removeItem(TokenKey)
}

const UserKey = 'user-info'

export function setUserInfo(value) {
    store.state.user.userInfo = JSON.parse(value)
}

export function getUserInfo() {
    return store.state.userInfo
}

export function removeUserInfo() {
    return sessionStorage.removeItem(UserKey)
}
